import { render, staticRenderFns } from "./DashboardEquipmentDetail.vue?vue&type=template&id=c6fac096&scoped=true&"
import script from "./DashboardEquipmentDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardEquipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEquipmentDetail.vue?vue&type=style&index=0&id=c6fac096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fac096",
  null
  
)

export default component.exports